<div class="m-t-20">
  <myp-product-search-picker
    sectionHeader="Associated Products"
    hint="Search for a PreSonus product by name, or enter a Fender SKU to associate..."
    [selectedHeader]="'Products Associated With This ' + (contentType | titlecase)"
    [products]="products"
    [disabled]="!!associatingProduct"
    [showProductLineSwitch]="true"
    [(associateWithProductLine)]="associateWithProductLine"
    [removeBusyMap]="removingProductAssociationMap"
    [associatingProduct]="associatingProduct"
    addTooltip="Associate This Product"
    removeTooltip="Remove This Product"
    (productSelected)="associateProduct($event)"
    (productRemoved)="removeProductAssociation($event)"
  ></myp-product-search-picker>
</div>
